export class CentroCusto {
  descricao = null;
  idPai = null;

  constructor(dadosCentroCusto) {
    this.descricao = dadosCentroCusto.descricao;
    this.idPai = dadosCentroCusto.idPai;
  }
}
